import type { Paginated } from '@partou/core';
import { inject, Injectable } from '@angular/core';
import { PaginatedSelectStore, type PaginatedSelectRequest } from '@partou/core';
import { type Observable } from 'rxjs';
import type { Group } from '../types';
import { GroupsApiService } from '../services/groups.api';

@Injectable()
export class GroupsSelectStore extends PaginatedSelectStore<Group> {
  constructor() {
    const api: GroupsApiService = inject(GroupsApiService);
    super(
      (request: PaginatedSelectRequest): Observable<Paginated<Group>> =>
        api.getGroups({
          locationId: request.params['locationId'] ?? '',
          nameSearch: request.searchTerm,
          limit: request.limit,
          offset: request.offset,
        }),
    );
  }

  setLocation(locationId: string): void {
    if (this.snapshot.params['locationId'] === locationId) return;
    this.patch({ selected: null, searchTerm: '' });
    this.setParams({ locationId });
  }
}
